export default "__VITE_ASSET__BmoCgQsR__"